import React from 'react';

export default function Terms() {
    return (
        <div className="policy-page">
            <div className="policy-container">
                <h1>Terms of Service</h1>
                <p className="policy-updated">Last Updated: January 2025</p>

                <section className="policy-section">
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By accessing and using the Big Hit Barbershop website and services, you accept
                        and agree to be bound by the terms and provisions of this agreement. If you do
                        not agree to these terms, please do not use our website or services.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>2. Services</h2>
                    <p>
                        Big Hit Barbershop provides professional barbering services including haircuts,
                        beard trims, shaves, and related grooming services. Our services are available
                        at our Las Vegas and Kenosha locations.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>3. Appointments & Scheduling</h2>
                    <ul>
                        <li>Appointments can be booked online through our booking platform or by phone</li>
                        <li>We recommend booking in advance, especially during peak hours</li>
                        <li>Walk-ins are welcome based on availability</li>
                        <li>Please arrive 5-10 minutes before your scheduled appointment</li>
                        <li>Late arrivals may result in shortened service time or rescheduling</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>4. Cancellation Policy</h2>
                    <p>
                        We understand that plans change. We ask that you provide at least 2 hours notice
                        if you need to cancel or reschedule your appointment. Repeated no-shows or
                        late cancellations may result in the requirement of a deposit for future bookings.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>5. Payment</h2>
                    <ul>
                        <li>Payment is due at the time of service</li>
                        <li>We accept cash or online payments</li>
                        <li>ATM machine available at location</li>
                        <li>Prices are subject to change without notice</li>
                        <li>Tips are appreciated but not required</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>6. Health & Safety</h2>
                    <p>
                        The health and safety of our clients and staff is our top priority. We maintain
                        strict sanitation standards and follow all local health regulations. We reserve
                        the right to refuse service to anyone who appears to have a contagious condition
                        or does not comply with our safety guidelines.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>7. Conduct</h2>
                    <p>
                        We strive to maintain a welcoming and respectful environment for all clients.
                        We reserve the right to refuse or terminate services to anyone who:
                    </p>
                    <ul>
                        <li>Behaves in a disrespectful or threatening manner</li>
                        <li>Is under the influence of drugs or alcohol</li>
                        <li>Engages in harassment of staff or other clients</li>
                        <li>Violates any of these terms of service</li>
                    </ul>
                </section>

                <section className="policy-section">
                    <h2>8. Intellectual Property</h2>
                    <p>
                        All content on this website, including text, images, logos, and graphics, is
                        the property of Big Hit Barbershop and is protected by copyright laws.
                        Unauthorized use or reproduction is prohibited.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>9. Limitation of Liability</h2>
                    <p>
                        Big Hit Barbershop is not liable for any damages resulting from the use of our
                        services or website. Our total liability shall not exceed the amount paid for
                        the specific service in question.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>10. Changes to Terms</h2>
                    <p>
                        We reserve the right to modify these terms at any time. Changes will be effective
                        immediately upon posting to this website. Your continued use of our services
                        constitutes acceptance of any modified terms.
                    </p>
                </section>

                <section className="policy-section">
                    <h2>11. Contact Information</h2>
                    <p>For questions about these Terms of Service, please contact us:</p>
                    <div className="policy-contact">
                        <p><strong>Las Vegas:</strong> (702) 675-6448</p>
                        <p>5651 S Grand Canyon Dr Suite 105, Las Vegas, NV 89148</p>
                        <br />
                        <p><strong>Kenosha:</strong> (262) 657-5055</p>
                        <p>6011 39th Ave, Kenosha, WI 53142</p>
                    </div>
                </section>
            </div>
        </div>
    );
}
